<template>
	<div>
		<!-- <el-dialog :visible.sync="showmodal" title="Update Status" :width="$vssWidth < 1000 ? '90%' : '30%'" @close="$emit('close-modal')"> -->
		<el-dialog :show-close="false" :visible.sync="showmodal" :width="$vssWidth < 1000 ? '90%' : '40%'"
			@close="$emit('close-modal')">
			<!-- CUSTOM HEADER -->
			<template slot="title">
				<div class="custom-dialog-header">
					<img src="@/assets/images/icons/back-icon.svg" class="back-icon" @click="$emit('close-modal')" />
					<!-- <span style="font-size: 24px; cursor: pointer; color: #080056" @click="$emit('close-modal')">&#8592;</span> -->

					<div class="divider"></div>

					<span class="header-text">Update Status</span>
				</div>
			</template>
			<div class="particulars-img-wrapper">
				<div class="container-fluid">
					<div class="row">
						<div class="col-md-12 col-lg-12 col-12">
							<label for="" class="label">Current Status</label>
							<input type="text" disabled v-model="capStatus" class="input" />
						</div>
						<div class="col-md-12 col-lg-12 col-12">
							<label for="" class="label">Updated By</label>
							<input type="text" disabled v-model="updatedBy" class="input" />
						</div>
						<div class="col-md-12 col-lg-12 col-12">
							<label for="" class="label">Date Last Updated</label>
							<div>
								<el-date-picker type="date" placeholder="Start Date" style="margin: 0" class="mr-3"
									v-model="booking.createdAt" />
							</div>

						</div>
						<div class="col-md-12 col-lg-12 col-12">
							<label for="" class="label">New status</label>
							<el-select v-model="statusobj.newstatus" placeholder="Select state">
								<el-option v-for="status in statuses" :key="status.value"
									:label="capitalize(status.name)" :value="status.value">
								</el-option>
							</el-select>
						</div>
					</div>
				</div>
			</div>

			<div class="button-wrapper">
				<button @click="$emit('close-modal')">Cancel</button>
				<base-button text="Update" :loading="loading" @click="updateStatus" />
			</div>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
// import VueScreenSize from 'vue-screen-size'

export default {
	props: {
		showmodal: Boolean,
		booking: Object,
		currentStatus: String,
		lastUpdated: String
	},
	data() {
		return {
			statusobj: this.getform(),
			loading: false,
			updatedBy: this.$store.getters.user.firstname + " " + this.$store.getters.user.lastname,
			statuses: [
				{
					name: 'Received at origin Terminal',
					value: 'received_at_origin_terminal',
				},
				{
					name: 'Consolidated',
					value: 'consolidated',
				},
				{
					name: 'Dispatched from origin terminal',
					value: 'dispatched_from_origin_terminal',
				},
				{
					name: 'In transit to destination terminal',
					value: 'in_transit_to_destination_terminal',
				},
				{
					name: 'Arrived at destination terminal',
					value: 'arrived_at_destination_terminal',
				},
				{
					name: 'Unloading',
					value: 'unloading',
				},
				{
					name: 'Destination Sorting',
					value: 'destination_sorting',
				},
				{
					name: 'Dispatched for delivery',
					value: 'dispatched_for_delivery',
				},
				{
					name: 'Delivered',
					value: 'delivered',
				},
				{
					name: 'Canceled',
					value: 'canceled',
				},
				{
					name: 'Handed off',
					value: 'handed_off',
				},
				{
					name: 'Delayed',
					value: 'delayed',
				},
			]

		}
	},
	// mixins: [VueScreenSize.VueScreenSizeMixin],
	methods: {
		getform() {
			return {
				newstatus: "",
				message: "",
			}
		},
		async updateStatus() {

			let request = {
				deliveryStatus: this.statusobj.newstatus,
				message: "Status Updated to " + this.statusobj.newstatus
			}

			try {
				this.loading = true

				await this.$_updateShippingStatusByDriver(this.booking?.id, request)
				this.loading = false
				this.$emit('booking-subaction-completed')
				this.$emit('refetchBooking')
				this.$emit('close-modal')
			} catch (error) {
				this.loading = false;
				this.handleError(error);
			}

		},
		capitalize(str) {
			let capitalizedstr = str ? str.charAt(0).toUpperCase() + str.slice(1) : ""

			return capitalizedstr
		},
	},
	watch: {
		showmodal() {
			console.log("booking created", this.booking)
		}
	},
	computed: {
		capStatus() {
			return this.capitalize(this.booking && this.booking.orderStatus ? this.booking.orderStatus : "N/A")
		},

		currentWidth() {
			return document.innerWidth
		}
	}
}
</script>

<style scoped>
.custom-dialog-header {
	display: flex;
	align-items: center;
	gap: 12px;
}

.back-icon {
	width: 22px;
	height: 22px;
	cursor: pointer;
}

.divider {
	width: 1px;
	height: 25px;
	background: #c4c4c4;
}

.header-text {
	font-size: 18px;
	font-weight: 600;
	color: #1f2d3d;
}

/* :deep(.my-date-picker .el-input__inner) {
  background-color: #EBF2FA !important;
} */


.row>:nth-child(3)>:nth-child(2) {
	/* background-color: #EBF2FA; */
	width: 100%;
}

.row>div>input {
	background-color: #EBF2FA;
}

.dialog {
	width: 100%
}

@media (max-width: 999px) {
	.dialog {
		width: 100%;
	}
}
</style>